module.exports = __webpack_public_path__ + "img/applybpo.f8dc8db0.png";